@if (showModal()) {
<div class="signup-logout-modal">
  <div class="modal-content">
    <div class="modal-flex-row">
      <div class="icon-col">
        <span class="icon-circle"><span class="icon-exclamation">!</span></span>
      </div>
      <div class="content-col">
        <div class="headline">Account Setup in Progress</div>
        <div class="subtext">Please sign in again to complete the setup process.</div>
      </div>
    </div>
    <div class="button-row">
      <button class="modal-action-btn" (click)="onConfirm()">CONTINUE</button>
    </div>
  </div>
</div>
}
